export default "__VITE_ASSET__CH$02Jan__"